import React, { Component } from 'react';
import { tabs } from '../constants';
import { getImage } from '../utils';
import './styles.scss';

type Props = {
  selectedTab: number;
  selectTab: Function;
  tabName: string;
};
type State = {
  defaultSelection: number;
};

export default class SideBar extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
  }

  setInitialState(): State {
    return { defaultSelection: 0 };
  }

  get tabList() {
    if (sessionStorage.getItem('roleId') === '2') {
      return tabs.filter((data) => data.name === 'Chats');
    } else if (
      sessionStorage.getItem('roleId') === '1' ||
      sessionStorage.getItem('roleId') === '4' ||
      sessionStorage.getItem('roleId') === '6'
    ) {
      return tabs.filter(
        (data) =>
          data.name === 'Analyze' || data.name === 'Configure' || data.name === 'Chats'
      );
    } else if (sessionStorage.getItem('roleId') === '3') {
      return tabs.filter((data) => data.name === 'Analyze');
    } else if (sessionStorage.getItem('roleId') === '5') {
      return tabs.filter((data) => data.name === 'Analyze' || data.name === 'Chats');
    }
  }
  render() {
    return (
      <div className='navbar-wrapper'>
        {this.tabList &&
          this.tabList.map((tab, index) => {
            return (
              <img
                key={index}
                className={
                  'tab clickable' + (this.props.selectedTab === index ? ' selected' : '')
                }
                src={getImage(`${tab.img}.svg`)}
                alt={tab.name.toLowerCase()}
                title={tab.name}
                onClick={() => {
                  if (tab.name === 'Chats') {
                    this.props.selectTab(0, tab.name);
                    this.setState({
                      defaultSelection: 1,
                    });
                  } else if (tab.name === 'Analyze') {
                    this.props.selectTab(1, tab.name);
                    this.setState({
                      defaultSelection: 2,
                    });
                  } else if (tab.name === 'Configure') {
                    this.props.selectTab(2, tab.name);
                    this.setState({
                      defaultSelection: 3,
                    });
                  } else {
                    this.props.selectTab(0, '');
                  }
                }}
              />
            );
          })}
      </div>
    );
  }
}
